export const partTypeMapping = [
    {
        keywords: [
            "integrated circuit",
            "ic",
            "logic",
            "flip flop",
            "gates",
            "divider",
            "counter",
            "register",
            "latch",
        ],
        category: "Logic",
        logicFunction: "AND",
    },
    {
        keywords: ["gate drive ic"],
        category: "Driver IC",
        logicFunction: "Driver",
    },
    {
        keywords: ["buffer", "driver"],
        category: "Logic",
        logicFunction: "Buffer",
    },
    {
        keywords: ["cpld"],
        category: "CPLD",
        logicFunction: "Configurable",
    },
    {
        keywords: ["opamp", "operational amplifier", "analog switches", "analog multiplexers"],
        category: "Linear",
        logicFunction: "Buffer",
    },
    {
        keywords: ["linear voltage regulator", "ldo", "linear", "dropout regulator"],
        category: "Power Management",
        logicFunction: "Regulator",
    },
    {
        keywords: ["dac", "digital to analog converter", "adc", "analog to digital converter", "data converter"],
        category: "Data Converter",
        logicFunction: "Decoder",
    },
    {
        keywords: ["clock generator", "pll", "phase locked loop", "frequency synthesizer"],
        category: "Clock and Timing",
        logicFunction: "Clock",
    },
    {
        keywords: ["clock/timing", "clock and timing"],
        category: "Clock and Timing",
        logicFunction: "Timer",
    },
    {
        keywords: ["memory", "ram", "rom"],
        category: "Memory",
        logicFunction: "Storage",
    },
    {
        keywords: ["microcontroller", "mcu", "embedded processor", "embedded controller"],
        category: "Embedded Processor",
        logicFunction: "Control Unit",
    },
    {
        keywords: ["battery management", "current & power monitor", "power management", "pmic"],
        category: "Power Management",
        logicFunction: "Monitor",
    },
    {
        keywords: ["motor driver ic", "power distribution switch", "power monitors & regulator"],
        category: "Power Management",
        logicFunction: "Driver",
    },
    {
        keywords: ["voltage regulator"],
        category: "Power Management",
        logicFunction: "Regulator",
    },
    {
        keywords: ["rf amplifier"],
        category: "RF Semiconductor",
        logicFunction: "Amplifier",
    },
    {
        keywords: ["rf transceiver", "rf semiconductor", "rf device"],
        category: "RF Semiconductor",
        logicFunction: "Receiver",
    },
    {
        keywords: ["fpga"],
        category: "FPGA",
        logicFunction: "Configurable",
    },
    {
        keywords: ["timer"],
        category: "Timer",
        logicFunction: "Counter",
    },
    {
        keywords: ["universal bus function", "translator", "level shifter", "interface - specialized"],
        category: "Interface",
        logicFunction: "Translator",
    },
];
//# sourceMappingURL=partTypeMapping.js.map